import { deleteErrFns } from "./mfaDeleteErrors";

import { FieldName, SmartErrorAlertProps } from "../../components/SmartErrorAlert";
import { createAccountStep1ErrorFns } from "./createAccount1Errors";
import { findMyAccountErrFns } from "./findMyAccountErrors";
import { forgotPasswordStep1ErrorFns } from "./forgotPassword1Errors";
import { forgotPasswordStep2ErrorFns } from "./forgotPassword2Errors";
import { forgotPasswordStep3ErrorFns } from "./forgotPassword3Errors";
import { forgotUsernameAndPasswordErrFns, forgotUsernameErrFns } from "./forgotUsernameErrors";
import { ErrorContentFns } from "./getAlertContent";
import { loginErrorFns } from "./loginErrors";
import { unlockAccountStep1ErrorFns } from "./unlockAccount1Errors";
import { step2ErrFnsSms } from "./mfaEnrollStep2Errors";
import { step1ErrFnsEmail, step1ErrFnsSms, step1ErrFnsVoice } from "./mfaEnrollStep1Errors";
import { mfaSendErrorFns } from "./mfaSendErrors";
import { mfaVerifyPasswordErrorFns } from "./mfaVerifyPasswordErrorFns";
import { mfaLoginGovDeliveryErrorFns }  from "./mfaGovDeliveryErrors";

type GenericErrorContentFns = ErrorContentFns<SmartErrorAlertProps, FieldName>;
export const getErrorContentFns = (name: SmartErrorAlertProps['name']): GenericErrorContentFns => {
    switch(name) {
        case 'Login':
            return loginErrorFns as GenericErrorContentFns;
        case 'CreateAccount1':
            return createAccountStep1ErrorFns as GenericErrorContentFns;
        case 'UnlockAccount1':
            return unlockAccountStep1ErrorFns as GenericErrorContentFns;
        case 'ForgotPassword1':
            return forgotPasswordStep1ErrorFns as GenericErrorContentFns;
        case 'ForgotPassword2':
            return forgotPasswordStep2ErrorFns as GenericErrorContentFns;
        case 'ForgotPassword3':
            return forgotPasswordStep3ErrorFns as GenericErrorContentFns;
        case 'ForgotUsername':
            return forgotUsernameErrFns as GenericErrorContentFns;
        case 'ForgotUsernameAndPassword':
            return forgotUsernameAndPasswordErrFns as GenericErrorContentFns;
        case 'FindMyAccount':
            return findMyAccountErrFns as GenericErrorContentFns;
        case 'MfaEnrollStep1Sms':
            return step1ErrFnsSms as GenericErrorContentFns;
        case 'MfaEnrollStep1Voice':
            return step1ErrFnsVoice as GenericErrorContentFns;
        case 'MfaEnrollStep1Email':
            return step1ErrFnsEmail as GenericErrorContentFns;
        case 'MfaEnrollStep2Email':
            return step2ErrFnsSms as GenericErrorContentFns;
        case 'MfaEnrollStep2Sms':
            return step2ErrFnsSms as GenericErrorContentFns;
        case 'MfaEnrollStep2Voice':
            return step2ErrFnsSms as GenericErrorContentFns;
        case 'MfaDeleteMethod':
            return deleteErrFns as GenericErrorContentFns;
        case 'MfaLoginSendCode':
            return mfaSendErrorFns as GenericErrorContentFns;
        case 'MfaLoginEnterCode':
            return mfaLoginGovDeliveryErrorFns as GenericErrorContentFns;
        case 'MfaVerifyPassword':
            return mfaVerifyPasswordErrorFns as GenericErrorContentFns;
    }
}